const imageURIs = {
    ambient_bright: require('./images/ambient_bright.png'),
    ambient_dark: require('./images/ambient_dark.png'),
    ambient_dim: require('./images/ambient_dim.png'),
    ambient_moderate: require('./images/ambient_moderate.png'),
    ambient_off: require('./images/ambient_off.png'),
    reload_button: require('./images/reload_button.png')
};

export default imageURIs;
